import { endpointsViews } from "../endpoints/endpointsViews";
import { fetchApi } from "../fetcher";

export async function createPendingViewSnapshot(
  projectId: number,
  snapshotId: string,
  image: Blob,
  annotatedSnapshotId?: string,
): Promise<void> {
  const form = new FormData();
  form.append("image", image);
  if (annotatedSnapshotId)
    form.append("annotatedSnapshotId", annotatedSnapshotId);

  const { method, url } = endpointsViews.snapshotCreatePending(
    projectId,
    snapshotId,
  );
  await fetchApi({ url, method, body: form });
}
